import { ReactNode } from 'react'
import { useOnboarding } from '../onboarding-provider'
import { Navigate } from 'react-router-dom'
import { RoutePath } from 'src/enums/routing'

export type IncompleteOnboardingOnlyProps = {
  children: ReactNode,
}

export function IncompleteOnboardingOnly({ children }: IncompleteOnboardingOnlyProps) {
  const { hasCompletedOnboarding } = useOnboarding()

  return (
    <div>
      { hasCompletedOnboarding
        ? <Navigate
          to={RoutePath.Root}
          replace
        />
        : children }
    </div>
  )
}
